import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/orgApi";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

const loadCtx = () => {
  try { return JSON.parse(localStorage.getItem("emr_context")); } catch { return null; }
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=authed
  const [context, setContextState] = useState(loadCtx());
  const token = localStorage.getItem("emr_token");

  useEffect(() => {
    if (!token) { setUser(false); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {
      localStorage.removeItem("emr_token");
      setUser(false);
    });
  }, [token]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("emr_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const setContext = (ctx) => {
    localStorage.setItem("emr_context", JSON.stringify(ctx));
    setContextState(ctx);
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("emr_token");
    localStorage.removeItem("emr_context");
    setContextState(null);
    setUser(false);
  };

  const isAdmin = !!user && (user.roles || []).includes("administrator");

  return (
    <AuthContext.Provider value={{ user, setUser, context, setContext, login, logout, isAdmin }}>
      {children}
    </AuthContext.Provider>
  );
}
